var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-wv_steak_house",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "section-modifier": _vm.sectionModifier,
          "menu-item-component": _vm.menuItemComponent,
          "content-area-top-layout": "",
          "content-area-bottom-layout": "",
          "is-tag-legend-hidden": "steak" === _vm.sectionModifier,
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-wv_steak_house",
        class: _vm.containerClasses,
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "section-modifier": _vm.sectionModifier,
          "menu-item-component": _vm.menuItemComponent,
          "content-area-top-layout": "",
          "content-area-bottom-layout": "",
          "is-tag-legend-hidden": "steak" === _vm.sectionModifier,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }